import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-timeline-list',
  components: {},
})
export default class TimelineList extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
